export default __webpack_public_path__ + "static/media/diary.7985a4cb.png";